import { IonButton } from "@ionic/react";

interface Props {
    setParticipantVisible: Function;
}
const ParticipantVisibleModal: React.FC<Props> = ({ setParticipantVisible }) => {
    return (
        <>

            <div className="generic-assesment-text-modal">
                <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">Make sure that the</h1>
                <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">participant is fully</h1>
                <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">visible in the box</h1>
                <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">while standing.</h1>
            </div>
        </>
    );
};
export default ParticipantVisibleModal;

